const steps = [
  { title: 'Travel Details' },
  { title: 'Passenger Details' },
  { title: 'Choose Plan' },
  { title: 'Buy now' }
];

export default steps;
